import { Skeleton } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface BookingSummarySkeletonProps {
  variant: 'regular' | 'mobile';
}

const BookingSummarySkeleton: FC<BookingSummarySkeletonProps> = ({
  variant,
}) => {
  if (variant === 'mobile') {
    return (
      <div className="flex w-full flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-6 w-24" />
        </div>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    );
  }

  // Regular variant (desktop)
  return (
    <div className="flex w-full flex-col gap-4 rounded-lg border border-neutral-pale p-4">
      {/* Trip details */}
      <div className="flex flex-col gap-3">
        <Skeleton className="h-6 w-40" />
        <div className="flex flex-col gap-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-3/4" />
        </div>
      </div>

      {/* Passengers */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-4 w-full" />
      </div>

      {/* Extras/Ancillaries */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>

      {/* Price breakdown */}
      <div className="flex flex-col gap-2 border-t border-neutral-pale pt-3">
        <div className="flex justify-between">
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-5 w-20" />
        </div>
        <div className="flex justify-between">
          <Skeleton className="h-5 w-28" />
          <Skeleton className="h-5 w-20" />
        </div>
      </div>

      {/* Total */}
      <div className="flex justify-between border-t border-neutral-pale pt-3">
        <Skeleton className="h-6 w-20" />
        <Skeleton className="h-6 w-24" />
      </div>
    </div>
  );
};

export default BookingSummarySkeleton;
